import { render } from "./GroupBasicProductFields.vue?vue&type=template&id=4da1ac80&scoped=true"
import script from "./GroupBasicProductFields.vue?vue&type=script&lang=js"
export * from "./GroupBasicProductFields.vue?vue&type=script&lang=js"

import "./GroupBasicProductFields.vue?vue&type=style&index=0&id=4da1ac80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da1ac80"]])

export default __exports__